import Login from '../pages/auth/Login.jsx';
import TrackingPortal from '../pages/Tracking/TrackingPortal.jsx';
import EtiquetaQr from '../pages/Tracking/EtiquetaQr.jsx';

export const authRoutes = [
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/tracking',
    component: TrackingPortal,
  },
  {
    path: '/tracking/:codigo',
    component: TrackingPortal,
  },
  {
    path: '/q/etq/:numero',
    component: EtiquetaQr,
  },
];

export default authRoutes;
